import { useEffect, useState, useCallback } from "react";
import {
  GetQualifiedInvoiceQuery,
  gqlClient,
  gqlHeader,
  runGqlQueryV2,
} from "@graffer-inc/smart-apply";
import { toast } from "react-toastify";

export const useQualifiedInvoiceShowContainer = ({
  qualifiedInvoiceId,
  applicationId,
}: {
  qualifiedInvoiceId: string;
  applicationId: string;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [invoice, setInvoice] = useState<
    GetQualifiedInvoiceQuery["qualifiedInvoice"] | undefined
  >(undefined);

  const onFetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await runGqlQueryV2(() =>
        gqlClient.getQualifiedInvoice(
          {
            id: qualifiedInvoiceId,
            applicationId,
          },
          gqlHeader("q"),
        ),
      );
      if (res.error) {
        throw res.error;
      }
      if (res.data?.qualifiedInvoice) {
        setInvoice(res.data.qualifiedInvoice);
      }
    } catch (e) {
      toast.error(
        "支払い明細書の取得に失敗しました。時間をおいてから、再度お試しください。",
      );
    } finally {
      setIsLoading(false);
    }
  }, [qualifiedInvoiceId, applicationId]);

  useEffect(() => {
    onFetch();
  }, [onFetch]);

  return {
    isLoading,
    invoice,
  };
};
